var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "#008215"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.941 3h-.514a.22.22 0 0 0-.184.114L5.21 7.98 3.757 5.647a.256.256 0 0 0-.082-.084.195.195 0 0 0-.102-.03h-.514c-.05 0-.077.072-.046.12l2.014 3.234c.094.15.274.15.37 0l3.59-5.768C9.017 3.072 8.99 3 8.941 3Z",
    fill: "#fff"
  })));
};
export default SvgSuccess;